<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Resultados</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Resultados</strong>
          </div>
          <b-row>
            <b-col lg="6">
              <b-button type="primary" variant="primary" @click="agregarResultado">
                <i class="fa fa-plus"></i> Agregar Resultado
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroResultados">
                <b-form-input
                  id="filtroResultados"
                  type="text"
                  placeholder="Filtrar Resultados"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col lg="12">
              <data-tables
                :data="data"
                :current-page.sync="pagina"
                :table-props="tableProps"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :prop="title.prop"
                  :label="title.label"
                  :key="title.label"
                  sortable="custom"
                  :formatter="formatter"
                ></el-table-column>

                <el-table-column label="Acciones" min-width="100px">
                  <template slot-scope="scope">
                    <el-button
                      v-for="button in customButtonsForRow(scope.row)"
                      :key="button.name"
                      type="text"
                      @click="button.handler"
                    >
                      <i v-bind:class="button.icon"></i>
                      {{ button.name }}
                    </el-button>
                  </template>
                </el-table-column>
              </data-tables>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <!--
    <editar-resultado ref="refEditarResultados" @actualizaResultados="buscar()"></editar-resultado>
    -->
    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Desactivar"
      class="modal-warning"
      v-model="modalEliminarResultado"
      @ok="eliminarResultado();"
      @cancel="modalEliminarResultado = false"
    >¿Está seguro que quiere desactivar este resultado?</b-modal>

    <b-modal
      title="Advertencia"
      cancel-title="Cancelar"
      ok-title="Activar"
      class="modal-warning"
      v-model="modalActivarResultado"
      @ok="activarResultado();"
      @cancel="modalActivarResultado = false"
    >¿Está seguro que quiere activar este resultado?</b-modal>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiActividades from "@/components/services/apiActividades";
import { globalesMixin } from "@/components/mixins/globalesMixin";
//import EditarProceso from "./EditarProceso";

export default {
  name: "Resultados",
  mixins: [tablasMixin, globalesMixin],
  components: {
    cSwitch,
    //EditarProceso
  },
  data: function() {
    return {
      tieneAcceso: true,

      gspnombre: "",
      gsanombre: "",
      modalEliminarResultado: false,
      modalActivarResultado: false,
      modalAgregarResultado: false,
      resultadoSelected: null,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      datosFormulario: [],
      data: [],
      titles: [
        {
          prop: "garcodigo",
          label: "Nombre"
        },
        {
          prop: "gardescripcion",
          label: "Descripción"
        },
        {
          prop: "garestado",
          label: "Estado Término"
        },
        {
          prop: "desc_activo",
          label: "Estado"
        }
      ],
      filters: [
        {
          prop: [
            "garcodigo",
            "gardescripcion",
            "garestado",
            "desc_activo",
          ],
          value: ""
        }
      ]
    };
  },
  methods: {
    
    customButtonsForRow(row) {
      if (row.garactivo === 0) {
        return [
          {
            name: " Activar",
            icon: "fa fa-plus",
            type: "success",
            handler: _ => {
              this.$session.start();
              this.modalActivarResultado = true;
              this.resultadoSelected = row.garcodigo;
            }
          }
        ];
      } else {
        return [
          {
            name: " Modificar",
            icon: "fa fa-pencil",
            type: "primary",
            handler: _ => {
              /*
              this.$refs.refEditarProceso.modalEditarProceso = true;
              this.$refs.refEditarProceso.visible = true;
              this.$refs.refEditarProceso.obtenerProceso(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                row.gspnombre,
                "MOD"
              );
              */
            }
          },
          {
            name: " Desactivar",
            icon: "fa fa-trash",
            type: "danger",
            handler: _ => {
              this.$session.start();
              this.modalEliminarResultado = true;
              this.resultadoSelected = row.garcodigo;
            }
          }
        ];
      }
    },
    
    buscar(p_garproced) {
      this.$Progress.start();

      return apiActividades
        .buscarResultado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gspnombre,
          this.gsanombre,
          p_garproced,
          "REC"
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          this.data = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if (column.property == "prifmodif" && row[column.property]) {
        return this.$moment(row[column.property]).format("DD-MM-YYYY");
      } else if (column.property == "pricodnum" && row[column.property]) {
        column.align = "is-right";
        return this.$numeral(row[column.property]).format("0");
      } else {
        return row[column.property];
      }
    },
    
    agregarResultado() {
      /*
      this.$refs.refEditarProceso.modalAgregarProceso = true;
      this.$refs.refEditarProceso.visible = true;
      this.$refs.refEditarProceso.pre_insertar(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        ""
      );*/
    },
    
    eliminarResultado() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .eliminarResultado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gspnombre,
          this.gsanombre,
          this.resultadoSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gspnombre"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalEliminarResultado = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    activarResultado() {
      event.preventDefault();
      this.$Progress.start();
      return apiActividades
        .activarResultado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.gspnombre,
          this.gsanombre,
          this.resultadoSelected
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "gspnombre"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.buscar("");
            this.modalActivarResultado = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    }
    
    
    
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.gspnombre = this.$route.query.gspnombre;
    this.gsanombre = this.$route.query.gsanombre;

    this.buscar("");
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
